import MmenuLight from "mmenu-light";
import luge from "@waaark/luge";
import Splitting from "splitting";
import Flickity from "flickity";
// import "flickity-fade";
import "flickity-imagesloaded";

Splitting();

window.Flickity = Flickity;

luge.settings({
	credits: {
		show: false
	}
});

// *********************
// Mobile menu
// - mmenu light docs: https://mmenujs.com/mmenu-light/docs.html
// *********************
const headerNav = document.querySelector(".header-nav");
if (headerNav) {
	const menu = new MmenuLight(headerNav, "(max-width: 899px)");
	menu.navigation();
	const drawer = menu.offcanvas();
	document.querySelector(".header-trigger").addEventListener("click", (event) => {
		event.preventDefault();
		drawer.open();
	});
}
// *********************
// Blog comments
// reply to comment button
const commentReplyButtons = document.querySelectorAll(".comment-form-button");
if (commentReplyButtons) {
	commentReplyButtons.forEach(function (item) {
		item.addEventListener("click", function () {
			item.nextElementSibling.classList.remove("hidden");
			item.nextElementSibling.querySelector("textarea").focus();
			item.remove();
		});
	});
}

document.addEventListener("DOMContentLoaded", () => {
	// Get a Quote - populate the Trusted Cert ID into hidden field
	setTimeout(() => {
		const hiddenField = document.querySelector('.gform_hidden[value="trustedFormIdValue"]');
		const trustedCertId = window.trustedForm.id;
		if (trustedCertId && hiddenField) {
			hiddenField.value = trustedCertId;
		}
	}, 3000);
});
